// Filters 2.0
import { reducer } from './newCollection';

export const TYPE = 'FILTERS_BY_CATEGORY';
export const ADD_POPULAR_RANGE_USED = 'ADD_POPULAR_RANGE_USED';
export const ADD_FILTERS_RECENCY_ORDER = 'ADD_FILTERS_RECENCY_ORDER';
export const CLEAR_FILTERS_RECENCY_ORDER = 'CLEAR_FILTERS_RECENCY_ORDER';

export const initialState = {
    elements: {},
    collections: {},
    isFetching: {},
    isError: {},
    collectionMetadata: {},
    popularRangeUsed: {},
    filterRecencyOrder: []
};

const tranformFiltersDataToMap = filtersData => {
    const filters = [];
    const filterIdToAttrMap = {};
    const filtersInfoByAttr = {};

    filtersData.forEach(currFilter => {
        filters.push(currFilter.attribute);
        filterIdToAttrMap[currFilter.id] = currFilter.attribute;
        filtersInfoByAttr[currFilter.attribute] = { ...currFilter };
    });

    return { filters, filterIdToAttrMap, filtersInfoByAttr };
};

const getElementsArr = ({ data }) => {
    return data && data.map(({ filters, categoryId, ...rest }) => ({
        id: categoryId,
        ...tranformFiltersDataToMap(filters),
        ...rest
    }));
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_${TYPE}`: {
            action.data.data = getElementsArr(action.data);
            const newState = reducer(state, action, TYPE);

            return { ...newState };
        }

        case ADD_POPULAR_RANGE_USED: {
            return {
                ...state,
                popularRangeUsed: {
                    ...state.popularRangeUsed,
                    [action.data.categoryId]: {
                        ...state.popularRangeUsed[action.data.categoryId],
                        [action.data.filterAttr]: action.data.isUsed
                    }
                }
            };
        }

        case ADD_FILTERS_RECENCY_ORDER: {
            return {
                ...state,
                filterRecencyOrder: action.data.filterRecencyOrder
            };
        }

        case CLEAR_FILTERS_RECENCY_ORDER: {
            return {
                ...state,
                filterRecencyOrder: []
            };
        }

        default:
            return reducer(state, action, TYPE);
    }
};
